<template>
  <div class="com-dialog">
    <el-dialog
      v-model="props.isShow"
      :width="props.width"
      :top="props.top||'15vh'"
      :fullscreen="fullscreen"
      :show-close="false"
      :close-on-click-modal="false"
      :align-center="props.alignCenter"
      :before-close="handleClose"
    >
      <template #header>
        <div class="header-left">
          <span class="header-title">{{ props.title }}</span>
        </div>
        <div class="header-right">
          <el-icon :size="20" @click="handleClose">
            <Close />
          </el-icon>
        </div>
      </template>
      <slot class="content"/>
    </el-dialog>
  </div>
</template>
  
  <script lang="ts" setup>
import { withDefaults, ref, defineEmits, defineProps } from "vue";
import { Close } from "@element-plus/icons-vue";

const emits = defineEmits(["update:isShow", "close"]);

interface PropType {
  isShow: boolean;
  width?: number;
  title?: string;
  alignCenter?: boolean;
  imgSrc?: string;
  top?: string;
}

const props = withDefaults(defineProps<PropType>(), {
  isShow: false,
  width: 0,
  title: "",
  alignCenter: false,
  imgSrc: "@src/static/png/header-icon.png",
  top: "5vh",
});

const fullscreen = ref<boolean>(false);

const handleClose = (): void => {
  emits("update:isShow", false);
  emits("close");
};
</script>
  
  <style lang="scss" scoped>
.com-dialog {
  :deep(.el-dialog) {
    padding: 0;
    border-radius: 10px;
    .el-dialog__header {
      height: 42px;
      padding: 0 10px 0 10px !important;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-image: url("../../assets/dialog-background.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 8px 8px 0 0;
      .header-left,
      .header-right {
        display: flex;
        align-items: baseline;
      }
      .header-left {
        img {
          height: 18px;
          width: 18px;
        }
        .header-title {
          margin-left: 10px;
          font-size: 16px;
       color: #fbfbfb;
        }
      }
      .header-right {
        .header-right-icon {
          img {
            width: 14px;
            height: 14px;
          }
        }
        .el-icon {
          margin-left: 16px;
          color: #fff;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    .el-dialog__body {
      height: calc(100% - 42px);
      max-height: 85vh;
      overflow: auto;
      width: 100%;
      padding: 30px;
    }
  }

}
</style>
  